<app-template-html-editor [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [maxlength]="maxlength" [label]="label" />
